export default __webpack_public_path__ + "static/B0250-ba9777415f87cde8a123d3da186e1f83.png";